<template>
  <div class="menu-mobile-box">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <nav role="navigation">
          <a href="/" class="navbar-brand" data-test="anchorMenuMobileLogo" v-show="!isExpanded">
            <!-- <img src="@/assets/images/phelcom/eyercloud_logo.svg" alt="Eyercloud logo" width="112" v-if="!isTempPaid"> -->
            <div class="clinic-box">
              <h1 v-if="session.currentClinic">
                {{ session.currentClinic.name }}
              </h1>
              <div class="">
                <p>
                  powered by
                </p>
                <img class="logo dark-logo" src="@/assets/images/phelcom/eyercloud_logo.svg" alt="Eyercloud logo" width="52"/>
                <img class="logo light-logo" src="@/assets/images/phelcom/eyercloud_logo_white.svg" alt="Eyercloud logo" width="52"/>
              </div>
            </div>
          </a>

          <div class="search-box" :class="{'open': patientList.length || isExamFilter || showLatestResults || isExpanded, 'expand': isExpanded}" v-if="!isSpecialist">
            <div class="form-group" :class="{'is-specialist': isExpanded && isSpecialist}">
              <IconSearchFilter @click="toggleExpandSearch()" class="filter-icon" v-if="!isSpecialist"/>

              <input
                v-if="searchMode === 'patient' && !isSpecialist"
                class="form-control"
                type="text"
                name="search"
                v-model="searchValue"
                :placeholder="isPatientRoute ? $t('patientSearch.searchInList') : $t('patientSearch.search')"
                @keyup="doSearch"
                @keypress.enter="showAllSearchedPatients"
                @click="handleInputClick()"
              />
              <p v-else-if="searchMode === 'exam' && !isSpecialist" class="no-margin">{{ $t('exam.filterExams') }}</p>

              <IconClose v-if="patientList.length ||
                               showLatestResults ||
                               isExpanded
                               && searchMode === 'patient'"
                         class="clear-search"
                         @click="clearSearch" />

              <div class="search-box-actions" v-if="isExamRoute && isExpanded || isSpecialist">
                <button
                  type="button"
                  class="btn btn-sm"
                  @click="toggleSearchMode()">
                  <IconFilter v-if="searchMode === 'patient'"/>
                  <IconClose v-else/>
                </button>
              </div>
            </div>

            <div class="list-group-box" v-if="!isPatientRoute && (showLatestResults || showPatientSearchResults)">
              <div class="" v-if="showLatestResults">
                <button class="btn btn-square" type="button" name="button" @click="doFilterExamListLastSevenDays()">
                  {{ $t('patientSearch.lastSevenDays') }}
                </button>

                <button class="btn btn-square" type="button" name="button" @click="doFilterExamListByEyerMaps()">
                  EyerMaps
                </button>

                <ul class="last-search-list">
                  <li>
                    <IconClock/>
                    <p>Aguiar de Souza</p>
                  </li>
                  <li>
                    <IconClock/>
                    <p>Maria</p>
                  </li>
                  <li>
                    <IconClock/>
                    <p>Bruno</p>
                  </li>
                  <li>
                    <IconClock/>
                    <p>Ricardo</p>
                  </li>
                  <li>
                    <IconClock/>
                    <p>Augusto</p>
                  </li>
                </ul>
              </div>

              <div class="patient-list-box" v-if="showPatientSearchResults && patientList.length">
                <ul class="list-group scrollbar">
                  <li class="list-group-item" v-for="(item, index) in patientList" :key="index" @click="doFilterExamListByPatientID(item)">
                    <IconPatientsSearch/>

                    <div class="">
                      <p>{{ item.fullName }}</p>

                      <div class="id-box">
                        <div class="icon-sub"></div>
                        <span>{{ $utils.getFormattedPatientDocumentWithSearchMatch(item, searchValue, $i18n) }}</span>
                      </div>
                    </div>

                    <small>{{ formatDate(item.lastExamDate) }}</small>
                  </li>
                </ul>

                <div class="search-all-box">
                  <IconSearchFilter/>

                  <p>{{ $t('patientSearch.searchAll') }}<strong>{{ searchValue }}</strong></p>

                  <small>{{ $t('patientSearch.pressEnter') }}</small>
                </div>
              </div>
            </div>

            <div class="exam-filter-box" v-if="showDateFilter && isExamRoute" id="examFilterBox">
              <ExamFilter v-if="isExamRoute"
                          @close="toggleExamFilter"
                          :currentProperties="examFilterStore.filter.filter.properties"
                          :currentDates="{ startDate: examFilterStore.filter.filter.startDate, endDate: examFilterStore.filter.filter.endDate }"/>
            </div>
          </div>

          <div class="menu-toggle" id="menuToggle" v-show="!isExpanded">
            <img class="dark-logo" src="@/assets/images/phelcom/eyercloud_logo.svg" alt="Eyercloud logo" width="112" v-if="isBackdropActive"/>
            <img class="light-logo" src="@/assets/images/phelcom/eyercloud_logo_white.svg" alt="Eyercloud logo" width="112" v-if="isBackdropActive"/>
            <input id="checkboxMenuToggle" type="checkbox" data-test="checkboxMenuToggle" @click="isBackdropActive = !isBackdropActive"/>
            <span class="menu-toggle-bar"></span>
            <span class="menu-toggle-bar"></span>
            <span class="menu-toggle-bar"></span>
            <ul class="menu-toggle-list" id="menu">
              <div class="">
                <MenuProfile mobile @do-toggle="closeMenu"/>
                <li class="nav-item" :class="active === 'exam' ? 'active' : ''">
                  <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" data-test="anchorMenuMobileExam" @click="open = false; examMenu();">
                    <IconExams/>
                    <span>{{ $t('menu.exams') }}</span>
                  </a>
                </li>
                <li class="nav-item" :class="active === 'patient' ? 'active' : ''" v-show="allowSynchronization">
                  <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" data-test="anchorMenuMobilePatients" @click="open = false; patientMenu()">
                    <IconPatients/>
                    <span>{{ $t('menu.patients') }}</span>
                  </a>
                </li>
                <!-- <li class="nav-item" :class="active === 'news' ? 'active' : ''">
                  <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" data-test="anchorMenuMobileNews" @click="open = false; openNewsModal()">
                    <IconNews/>
                    <span>{{ $t('menu.news') }}</span>
                  </a>
                </li> -->
                <li v-if="isDocsAvailable" :class="active === 'docs' ? 'active' : ''">
                  <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" data-test="anchorMenuMobileDocs" @click="open = false; docsMenu()">
                    <i class="fa fa-code" aria-hidden="true"></i>
                    <span>{{ $t('menu.docs') }}</span>
                  </a>
                </li>
                <BaseFeature feature="backoffice">
                  <li v-if="!isSpecialist" :class="active === 'backoffice' ? 'active' : ''">
                    <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" data-test="anchorMenuMobileBackoffice" @click="open = false; backofficeMenu()">
                      <IconEye/>
                      <span>Backoffice</span>
                    </a>
                  </li>
                </BaseFeature>
              </div>
              <div class="">
                <li class="nav-item" v-show="allowSynchronization">
                  <a class="nav-link" :href="helpcenterUrl" target="_blank" data-test="anchorMenuMobilePatients">
                    <IconHelpMenu/>
                    <span>{{ $t('menu.help') }}</span>
                  </a>
                </li>
                <li class="nav-item">
                  <div class="form-floating">
                    <div class="form-check form-switch" @click.prevent="toggleTheme">
                      <IconMoon/>
                      <label class="form-check-label" for="darkModeMobile">{{ $t('menu.darkMode') }}</label>
                      <input class="form-check-input" type="checkbox" role="switch" id="darkModeMobile" data-test="checkboxDarkModeMobile" :checked="userTheme == 'dark-theme'"/>
                    </div>
                  </div>
                </li>
                <li :class="active === 'config' ? 'active' : ''">
                  <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" data-test="anchorMenuMobileSettings" @click="open = false; settingsMenu()">
                    <IconSettings/>
                    <span>{{ $t('createClinic.configuration') }}</span>
                  </a>
                </li>
                <div class="powered-box">
                  <p class="d-inline-block">POWERED BY</p>
                  <a href="https://phelcom.com/" class="logo d-inline-block" target="_blank">
                    <img class="dark-logo" src="@/assets/images/phelcom/phelcom_logo_horizontal_blue.svg" alt=""/>
                    <img class="light-logo" src="@/assets/images/phelcom/phelcom_logo_horizontal_white.svg" alt=""/>
                  </a>
                  <img class="aws-logo" src="@/assets/images/erjart/logo_aws.svg" alt="Logo AWS" width="27"/>
                  <p class="d-inline-block">v {{ appVersion }}</p>
                </div>
              </div>
            </ul>
          </div>
        </nav>
      </div>

      <div v-if="isBackdropActive" class="offcanvas-backdrop fade show"></div>
    </nav>

    <div class="header-filter-box" v-if="hasFilterItems && isExamRoute && isSmallScreen">
      <p>{{ $t('patientSearch.searchingFor') }}</p>

      <div class="">
        <span id="tag_patient" data-value="patient" class="tag2 alert" v-if="currentFilter.patientID">
          <span>{{ patientFullName }}</span>
          <a href="#" @click="clearFilteredList('name')">
            <IconCross/>
          </a>
        </span>

        <span id="tag_date" data-value="date" class="tag2 alert" v-if="currentFilter.startDate || currentFilter.endDate">
          <span>{{ `${currentFilter.startDate} ${$t('until')} ${currentFilter.endDate}` }}</span>
          <a href="#" @click="clearFilteredList('date')">
            <IconCross/>
          </a>
        </span>

        <template v-for="(item, key) in currentFilter.properties" :key="key">
          <span :id="`tag_${key}`" :data-value="key" class="tag2 alert" v-if="item">
            <span>{{ $t(`patientSearch.${key}`) }}</span>
            <a href="#" @click="clearFilteredList(key)">
              <IconCross/>
            </a>
          </span>
        </template>

        <button class="btn btn-outline-secondary" type="button" name="button" @click="clearFilteredList('all')">{{ $t('patientSearch.cleanFilters') }}</button>
      </div>

    </div>

    <teleport to="body">
      <PatientListSearchedOffcanvas :offcanvas_id="'PatientListSearchedOffcanvas'" ref="patientListSearchedOffcanvas"/>
    </teleport>
  </div>
</template>

<style src="./MenuMobileLinks.scss" lang="scss" scoped></style>
<script src="./MenuMobileLinks.js"></script>
